<template>
  <div class="view">
    <h1>{{ getProduct.name }}</h1>
    <img
      :src="getProduct.thumbnail"
      :alt="getProduct.name"
      v-if="getProduct.thumbnail !== ''"
    />
    <p>{{ getProduct.description }}</p>
    <router-link to="/product">他の商品はこちら</router-link>
  </div>
</template>

<script>
import products from "../assets/products.json";
import { setMeta } from "../lib/meta";

export default {
  mounted() {
    if (this.getProduct === undefined) {
      this.$router.push("/not-found");
      return;
    }
    setMeta({
      subtitle: this.getProduct.name,
      description: this.getProduct.description,
      path: this.$route.path,
      image: this.getProduct.thumbnail
    });
  },
  computed: {
    getProduct() {
      const result = products.find(
        product => product.path === this.$route.params.slug
      );
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
  font-size: 1.5em;
  padding: 1em 0;
}
img {
  margin: 1em auto;
  max-width: 600px;
  width: 100%;
}
p {
  margin: 0 auto;
  width: 960px;
}
a {
  text-align: right;
  margin: 1em 0;
  padding: 0 1em;
}
</style>
